import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import CrmLayout from './CrmLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pipeline from './pages/Pipeline';
import Leads from './pages/Leads';
import DealDetail from './pages/DealDetail';
import Accounts from './pages/Accounts';
import FollowUps from './pages/FollowUps';
import Team from './pages/Team';

export default function CrmApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route element={<CrmLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="pipeline" element={<Pipeline />} />
          <Route path="leads" element={<Leads />} />
          <Route path="followups" element={<FollowUps />} />
          <Route path="deals/:id" element={<DealDetail />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="team" element={<Team />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
